/**
 * Represents the map widget of the Search Results page
 *
 * This object manages the event handling and rendering of the map. It also maintains:
 * * The link between listings and their markers
 * * The position and visibility of the InfoBox popup
 * @param {string} id The DOM identifier for the map element, including its "#" character
 */
function SearchMap(id) {
    this.id = id;
    this.elem = document.getElementById(id);
    this.map = null;
    this.markers = [];
    this.bounds = new google.maps.LatLngBounds();

    // InfoBox options
    this.infoWindow = new SearchMapInfoBox();
    this.infoWindowMulti = new SearchMapInfoBoxMulti();

    this.mapOptions = {
        maxZoom : 20,
        minZoom : 4,
        zoom: $(this.elem).data('zoom') || 8,
        scrollwheel: false,
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        scaleControl: false,
        streetViewControl: false,
        overviewMapControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [{"visibility": "off"}]
            },{
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            },{
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            },{
                "featureType": "poi",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            },{
                "featureType": "road",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            },{
                "featureType": "transit",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            },{
                "featureType": "water",
                "elementType": "all",
                "stylers": [{"visibility": "on"}]
            }
        ]
    };

    //Default to the location's lat/lng if provided
    if($(this.elem).data('lat')) {
        this.mapOptions.center = { lat: $(this.elem).data('lat'), lng: $(this.elem).data('lng') };
    }

    // Trigger a refresh when the Redo Search in Map button is clicked.
    jQuery(document).on("triggerMapRefresh", this.triggerRefresh.bind(this));

    // Fitting all the markers when changing displays.
    jQuery(document).on("triggerMarkerBounds", this.fitMarkers.bind(this));

    // Handle the "less/more map" button being clicked, and when display types change
    jQuery(document).on("searchFormResizeEnd searchFormChangeDisplay", "#search-results-page", this.render.bind(this));

    // Rerender infobox on close
    jQuery(document).on('reRenderInfoBox', "#map-section", this.render.bind(this));

    // Handle the "less/more map" button being clicked, and when display types change
    jQuery(document).on("unitTileHovered", this.evtUnitTileHovered.bind(this));

    // Attach an event handler for when search requests finish
    jQuery(document).on(Search.evtSearchComplete, this.searchComplete.bind(this));

    this.initialize();
}

/**
 * Adds event listeners for when various actions occur on the map
 *
 * This mostly deals with rerendering the map and updating buttons/statuses
 */
SearchMap.prototype.addListeners = function() {
    var self = this;

    // Refresh results when dragging the map arround
    google.maps.event.addListener(this.map, 'dragend', function() {
        google.maps.event.addListenerOnce(self.map, 'idle', function() {
            self.mapMoved();
        });
    });
    // Refresh results when Map zoom changes (might cause issues when changing/resizing map area?)
    google.maps.event.addListenerOnce(this.map, 'tilesloaded', function() {
        google.maps.event.addListener(self.map, 'zoom_changed', function() {
            // Idling here for when zoom is clicked in quick succession triggering a refresh
            // after each click instead of at the end of their final requested zoom level
            google.maps.event.addListenerOnce(self.map, 'idle', function() {
                self.mapMoved();
            });
        });
    });

    google.maps.event.addListener(this.infoWindow, 'domready', function(){
        self.infoWindowMulti.close();
    });
    google.maps.event.addListener(this.infoWindowMulti, 'domready', function(){
        self.infoWindow.close();
    });
};

/**
 * Triggers when the map has been panned, zoomed, or otherwise changed
 * in a way that may trigger a new search
 **/
SearchMap.prototype.mapMoved = function() {
    if(jQuery("#redoSearchWhenMoved :checked").length === 1){
        setTimeout(function() {
            jQuery("#redoSearchWhenMoved").trigger("triggerMapRefresh");
        }, 300);
    } else {
        jQuery("#redoSearchWhenMoved").hide();
        jQuery("#triggerRefreshButton").show();
    }
};

/**
 * Adds a single marker object to the map
 * @param {Object} listing A single search result
 */
SearchMap.prototype.addMarker = function(listing) {
    var self = this;
    
    // Normalize
    if(listing.Lat) listing.lat = listing.Lat;
    if(listing.Lng) listing.lng = listing.Lng;
    
    if((listing.lat && listing.lat != '0.000000') && (listing.lng && listing.lng != '0.000000')) {
        // Recreate the marker as a Google Maps marker
        marker = new SearchMapMarker(this.map, listing);
        marker.infoWindow = this.infoWindow;

        // Pushing marker with all the goodies
        this.markers.push(marker);
    }
};

/**
 * Adds a multi marker object to the map
 * @param {Array} listings An array of search results
 */
SearchMap.prototype.addMarkerMulti = function(listings) {
    if((listings[0].lat && listings[0].lat != '0.000000') && (listings[0].lng && listings[0].lng != '0.000000')) {
        // Recreate the marker as a Google Maps marker
        marker = new SearchMapMarkerMulti(this.map, listings);
        marker.infoWindow = this.infoWindowMulti;

        // Pushing marker with all the goodies
        this.markers.push(marker);
    }
};

/**
 * Adds multiple marker objects to the map
 * @param {Object[]} listings An array of search results
 */
SearchMap.prototype.addMarkers = function(listings) {
    multiListings = [];
    var singleListings = [];
    //For every listing
    for(var x = 0; x < listings.length; x++) {
        var listing = listings[x];
        //Compare with every listing
        for(var y = 0; y < listings.length; y++) {
            var compare = listings[y];
            //Compare the outer listing with the inner listing on their geo coords
            if(listing.unitID != compare.unitID && listing.lat == compare.lat && listing.lng == compare.lng) {
                //If the coords match, and listing hasn't been added to a group, add the listing to multi listings
                if(!multiListings[listing.lat]){
                    multiListings[listing.lat] = [];
                }
                if(!multiListings[listing.lat][listing.lng]){
                    multiListings[listing.lat][listing.lng] = [];
                }
                if(!listings[x].added){
                    multiListings[listing.lat][listing.lng].push(listing);
                    listings[x].added = true;
                }
                if(!listings[y].added){
                    multiListings[listing.lat][listing.lng].push(compare);
                    listings[y].added = true;
                }
            }
        }

        if(!listings[x].added) {
            singleListings.push(listing);
        }
    }

    //Add the single listings as single markers
    for(var i = 0; i < singleListings.length; i++) {
       this.addMarker(singleListings[i]);
    }

    //Add the multiple listings as multi markers
    var keys = objKeys(multiListings);
    for(var i = 0; i < keys.length; i++) {
        var group = multiListings[keys[i]];
        var gKeys = objKeys(group);
        for (var j = 0; j < gKeys.length; j++) {
            var listings = group[gKeys[j]];
            this.addMarkerMulti(listings);
        }
    }
}

function objKeys(obj) {
  var keys = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) keys.push(key);
  }
  return keys;
}

/**
 * Event triggered when a tile is hovered over by the mouse in the search results list
 * @param  {Object} evt     An event emitted by the SearchList object
 * @param  {Object} listing A search result object
 */
SearchMap.prototype.evtUnitTileHovered = function(evt, listing) {
    var unitID = $(listing).data('unitid');

    // check through all markers
    for(var i = 0; i < this.markers.length; i++) {
        if(this.markers[i].markerType === 'single') {
            if(this.markers[i].listing.unitID == unitID) {
                this.markers[i].bounce();
            }
        } else {
            // check through all listings on multi marker
            for(var j = 0; j < this.markers[i].listings.length; j++) {
                if(this.markers[i].listings[j].unitID == unitID) {
                    this.markers[i].bounce();
                }
            }
        }
    }
};

/**
 * Fits the bounds of the map to the markers present on it
 *
 * NOTE: This method will trigger a "zoom" action on the map, simulating a user
 * zooming in/out of that geographic area.
 * @param  {SearchMapMarker[]} markers An array of marker objects
 */
SearchMap.prototype.fitMarkers = function(markers) {
    var bounds = new google.maps.LatLngBounds();

    for(var i = 0; i < this.markers.length; i++) {
        bounds.extend(this.markers[i].getPosition());
    }

    this.map.fitBounds(bounds);
};

/**
 * Initializes the map. Should be called on page-load for the map to work
 */
SearchMap.prototype.initialize = function() {
    var listingsData = $("#listings-data");

    if(listingsData.length === 0) {
        return;
    }

    //Default to the location coordinates if no search results were found
    if(!this.mapOptions.center && listingsData.data('listings').length === 0 && $(this.elem).data('location-lat')) {
        this.mapOptions.center = { lat: $(this.elem).data('location-lat'), lng: $(this.elem).data('location-lng') };
    }

    this.map = new google.maps.Map(document.getElementById(this.id), this.mapOptions);

    if(listingsData.data('listings').length > 0) {
        // Add the markers from the JSON
        this.addMarkers(listingsData.data('listings'));

        // Zoom in only if the lat/lng haven't been provided
        if(!this.mapOptions.center) {
            this.fitMarkers();
        }
    }

    this.addListeners();

};

/**
 * Shows any markers currently in the array.
 */
SearchMap.prototype.showMarkers = function() {
    this.setAllMap(this.map);
};

/**
 * Re-renders the existing map
 * This is excellent for when a window is being resized, or a map is being shown after having been
 * hidden for a while.
 */
SearchMap.prototype.render = function() {
    if(this.map) {
        google.maps.event.trigger(this.map,'resize');
    } else {
        this.initialize();
    }
};

/**
 * Sets the map on all markers in the array.
 */
SearchMap.prototype.setAllMap = function(map) {
    for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(map);
    }
};

/**
 * Triggers a new search event from the map widget
 *
 * This is generally called due to a user action such as panning or zooming
 */
SearchMap.prototype.triggerRefresh = function() {

    jQuery("#map-loader-searching").show();
    jQuery("#map-loader-no-results").hide();
    jQuery("#map-loader-results").hide();

    if(jQuery("#redoSearchWhenMoved :checked").length === 0){
        jQuery("#redoSearchWhenMoved").show();
        jQuery("#triggerRefreshButton").hide();
    }

    if(typeof this.map == 'undefined' || this.map === null) return;

    var center = this.map.getCenter();
    var bounds = this.map.getBounds();
    var changes = {};

    changes.ne_lat = bounds.getNorthEast().lat();
    changes.ne_lng = bounds.getNorthEast().lng();
    changes.sw_lat = bounds.getSouthWest().lat();
    changes.sw_lng = bounds.getSouthWest().lng();
    changes.zoom = this.map.getZoom();
    changes.center_lat = center.lat();
    changes.center_lng = center.lng();

    search_form.change(changes);

    // Reset the page number to 1 when the map location/zoom changes
    $("#pageNumber").val("1");

    var search = new Search();

    search.execute();
};

/**
 * Executes when a search finishes executing, updating the search form with the results
 * @param  {Object} res    The results returned from the server
 * @param  {Search} search The populated Search object that initiated the search
 */
SearchMap.prototype.searchComplete = function(evt, res, search) {

    // Clear all markers from the map
    this.setAllMap(null);
    this.markers = [];

    // Add the new markers
    this.addMarkers(res.listings);
    jQuery("#map-loader-searching").hide();
    renderCarousel();
};


/**
 * Loader for html-initialized maps (vs embedded <script> tags)
 */
jQuery(new_map.initializeFromHTML);

window.SearchMap = SearchMap;



//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/SearchMap.js
// module id = 7
// module chunks = 0